
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/time-series/create",
      function () {
        return require("private-next-pages/time-series/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/time-series/create"])
      });
    }
  